import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Lyanka from "@/pages/Lyanka";
import Vision from "@/pages/Vision";
import Contact from "@/pages/Contact";
import { PrivacyPolicy, TermsOfService, RefundPolicy, CookiePolicy } from "@/pages/Legal";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/lyanka-ai" element={<Lyanka />} />
                        <Route path="/vision" element={<Vision />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/terms-of-service" element={<TermsOfService />} />
                        <Route path="/refund-policy" element={<RefundPolicy />} />
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster theme="dark" richColors position="bottom-right" />
            </BrowserRouter>
        </div>
    );
}

export default App;
